export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fc640a7466aa090d0f364ee989ff25b8ab2b7a9f5&name=fetchTypeahead!'